import React from 'react';
import './workscard.scss';
import { Tabs, Radio } from 'antd';
import data from "../data.json"; 
import Bigpicture from "bigpicture";
import TweenOne from 'rc-tween-one';
const { TabPane } = Tabs;

function WorksCard(props) {
    return (
        <div className="works-card">
            <div className="home-banner-background">
               
            </div>
            <Tabs defaultActiveKey="0" tabPosition={"left"} >
                {
                    data.works.map((item, index)=>{
                        return <TabPane tab={
                            <div className="tab-title-box">
                                <div className="title">{item.title}</div>
                                <div className="sub-title">{item.sub_title}</div>
                            </div>
                        } key={index}>
                           <ul>
                              {item.img_url.map((urlitem,urlindex)=>
                                {
                                return <li key={urlindex} onClick={(e)=>{
                                    if(urlitem.video){
                                        Bigpicture({
                                            el:e.target,
                                            vidSrc:urlitem.video,
                                        })
                                    }
                                    else{
                                        Bigpicture({
                                            el:e.target,
                                            imgSrc:urlitem.url,
                                        })
                                    }
                                }}>
                                    <img src={urlitem.url} />
                                    </li>
                                }
                              )}
                           </ul>
                        </TabPane>
                    })
                }
            </Tabs>
        </div>
    );
}

export default WorksCard;